import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SingleOption = ({ option, id, correctAnswer }) => {
    const checkAnswer = (givenAnswer) => {
        if (givenAnswer === correctAnswer) {
            return toast('Yes, Correct');
        } else {
            return toast('Oops! UnCorrect');
        }
    }
    return (
        <div className="col">
            <div className="card">
                <div className="card-body">
                    <div className="flex">
                        <input className="" type="radio" name={`${id}`} onClick={() => checkAnswer(option)} />
                        <label className="pl-3 font-semibold text-sm" >
                            {option}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleOption;